import type { ChipProps } from '@mui/material'
import { Chip } from '@mui/material'

import type { EnergyBidPtuSource } from '@/features/bidding/types/bidDetail/EnergyBidSnapshot'

export type SourceBadgeProps = Readonly<{
  source: EnergyBidPtuSource
  size?: ChipProps['size']
}>

const COLOR_BY_SOURCE: Record<Exclude<EnergyBidPtuSource, 'UNKNOWN'>, ChipProps['color']> = {
  BOT: 'warning',
  'D-1': 'default',
}

const LABEL_BY_SOURCE: Record<Exclude<EnergyBidPtuSource, 'UNKNOWN'>, string> = {
  BOT: 'Bot',
  'D-1': 'D-1',
}

/**
 * Small chip showing the origin of a PTU's latest change.
 *
 * - **Bot** — the bid automation submitted the change
 * - **D-1** — the change came from the day-ahead baseline
 * - **UNKNOWN** — renders nothing (backend field not yet shipped)
 */
export default function SourceBadge({ source, size = 'small' }: SourceBadgeProps) {
  if (source === 'UNKNOWN') return null

  return <Chip color={COLOR_BY_SOURCE[source]} label={LABEL_BY_SOURCE[source]} size={size} variant="outlined" />
}
